import React from "react";
import ReactDOM from "react-dom/client";
import "./CSS/index.css";
import App from "./App";
import { initErrorLogger } from "./utils/errorLogger";

initErrorLogger();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />, document.getElementById("root"));
